import posthog from 'posthog-js';
import UserInfoApi from '@/api/UserInfoApi';
import auth from '@/utils/auth';
import userStore from '../store/modules/user';

const trackingServices = {

  getPostHogInstance() {
    const apiHost = 'https://eu.posthog.com';
    auth.getConf().then((response) => {
      posthog.init(response.CONF.TOKEN_POSTHOG, {
        api_host: apiHost,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false,
      });
      if (!posthog.get_distinct_id().includes('@')) {
        UserInfoApi.getUserInfo().then((info) => {
          posthog.identify(info.content.email.toLowerCase());
        });
      }
    });
    return posthog;
  },

  logout() {
    posthog.capture('User Logout', { internal_id: userStore.state.user.id });
    posthog.reset();
  },

  documentViewed() {
    posthog.capture('Document Viewed', { internal_id: userStore.state.user.id });
  },

  documentShared(duration) {
    posthog.capture('Document Shared', {
      duration,
      internal_id: userStore.state.user.id,
    });
  },

  documentAdded() {
    posthog.capture('Document Added', { internal_id: userStore.state.user.id });
  },

  collectorActivated() {
    posthog.capture('Collector Activated', { internal_id: userStore.state.user.id });
  },

  passwordStocked() {
    posthog.capture('Password Stocked', { internal_id: userStore.state.user.id });
  },

  folderCreated() {
    posthog.capture('Folder Created', { internal_id: userStore.state.user.id });
  },

  exportSafebox() {
    posthog.capture('Document Exported', { internal_id: userStore.state.user.id });
  },

  disabledAgreement() {
    posthog.capture('User Paperless Agreement Denied', { internal_id: userStore.state.user.id });
  },

  activateAgreement() {
    posthog.capture('User Paperless Agreement Reactivated', { internal_id: userStore.state.user.id });
  },

};

export default trackingServices;
